import type {ReactElement} from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {ClickableDiv} from '@Components/clickable-div';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {getPlanLockedAccountMessage} from '@Libraries/social-media-account.library';
import type {PlanLockedUpgradePillProps} from './plan-locked-upgrade-pill.types';
import {PLAN_LOCKED_UPGRADE_PILL_TOOLTIP_DELAY} from './plan-locked-upgrade-pill.types';
import styles from './plan-locked-upgrade-pill.module.scss';

export function PlanLockedUpgradePill({onClick, tooltip, textSize = TextSize.SM, blockClasses = ''}: PlanLockedUpgradePillProps): ReactElement {
  const getPillContent = (): ReactElement => {
    return (
      <>
        <Icon icon="icon-crown" className={styles.upgradePillCrown} size={IconSize.SIZE_ICON_12} />
        <Text className={styles.upgradePillText} size={textSize} bold val={window.i18next.t('pmwjs_upgrade_to_use')} />
      </>
    );
  };

  const getPill = (): ReactElement => {
    if (!onClick) {
      return <div className={`${styles.upgradePill} ${blockClasses}`}>{getPillContent()}</div>;
    }

    return (
      <ClickableDiv className={`${styles.upgradePill} ${styles.clickable} ${blockClasses}`} onClick={onClick}>
        {getPillContent()}
      </ClickableDiv>
    );
  };

  if (!tooltip) {
    return getPill();
  }

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="top"
      delay={PLAN_LOCKED_UPGRADE_PILL_TOOLTIP_DELAY}
      overlay={
        <Tooltip id={tooltip.id} className={tooltip.tooltipClasses} style={tooltip.style}>
          <Text size={TextSize.XSMALL} val={getPlanLockedAccountMessage()} />
        </Tooltip>
      }
    >
      {getPill()}
    </OverlayTrigger>
  );
}
